// extracted by mini-css-extract-plugin
export default {"wrapper":"DA-z","viewport":"EA-z","container":"FA-z","slide":"GA-z"};